import { styled } from '@mui/material';
import Box from '@mui/material/Box';

export const RuleEditorContainerBox = styled(Box)`
    display: flex;
    flex-direction: column;
    width: 68%;
    padding: 10px;
    color: #ffffff;
`;
